// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._backoffice_empatik[data-v-58f4bd2c]{font-family:Montserrat,sans-serif!important}", "",{"version":3,"sources":["webpack://./resources/js/components/backoffice/notifiche/NotificheRoute.vue"],"names":[],"mappings":"AACA,sCACE,2CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
